export default "__VITE_ASSET__BOhEyiil__"